import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Modulo',
    description: 'Modulo simplifies the design journey by offering a centralized platform for accessing ready-to-copy Webflow components.',
    url: getOrigin()
}
